import { render } from "./PortableTextImage.vue?vue&type=template&id=613b0b00"
import script from "./PortableTextImage.vue?vue&type=script&lang=js"
export * from "./PortableTextImage.vue?vue&type=script&lang=js"

import "./PortableTextImage.vue?vue&type=style&index=0&id=613b0b00&lang=scss"

import exportComponent from "/tmp/build_cd2b88ef/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__